@if (timetableEntry) {
  <div>
    @if (timetableEntry.id!==0) {
      <h2>Eintrag bearbeiten</h2>
    }
    @if (timetableEntry.id===0) {
      <h2>Eintrag erstellen</h2>
    }
    <div class="grid">
      <div class="col-2"><label for="editHost">Dozierende:</label></div>
      <div class="col-10"><input type="text" id="editHost" pInputText [(ngModel)]="timetableEntry.host" style="width: 100%" /></div>
      <div class="col-2"><label for="editSubtitle">Untertitel:</label></div>
      <div class="col-10"><input type="text" id="editSubtitle" pInputText [(ngModel)]="timetableEntry.subtitle" style="width: 100%" /></div>
      <div class="col-2"><label for="editTitle">Titel:</label></div>
      <div class="col-10"><input type="text" id="editTitle" pInputText [(ngModel)]="timetableEntry.title" style="width: 100%" /></div>
      <div class="col-2"><label for="editMaxAttendees">Maximale Zahl Teilenehmer:</label></div>
      <div class="col-10"><input type="number" id="editMaxAttendees" pInputText [(ngModel)]="timetableEntry.maxAttendees" style="width: 10ex; margin-right: 1ex" />0 wird als unbegrenzt ausgewiesen und behandelt.</div>
      <div class="col-2"><label for="editTimeslot">Zeitslot:</label></div>
      <div class="col-10"><p-select [options]="timeslotItems" [(ngModel)]="timetableEntry.timeslotId" inputId="editTimeslot" class="fullWidth"></p-select></div>
      <div class="col-2"><label for="editRoom">Ort:</label></div>
      <div class="col-10"><p-select [options]="roomItems" [(ngModel)]="timetableEntry.roomId" inputId="editRoom" class="fullWidth"></p-select></div>
      <div class="col-2"><label for="onlineCheckbox">Auch online:</label></div>
      <div class="col-10"><p-checkbox [(ngModel)]="timetableEntry.online" [binary]="true" inputId="onlineCheckbox"></p-checkbox></div>
      <div class="col-2"><label for="editType">Typ:</label></div>
      <div class="col-10">
        <p-select [options]="types" [(ngModel)]="timetableEntry.type" inputId="editType" class="fullWidth">
          <ng-template pTemplate="selectedItem">
            @if (timetableEntry.type) {
              <div>{{timetableEntry.type|translate}}</div>
            }
          </ng-template>
          <ng-template pTemplate="item" let-type>
            <div>{{type|translate}}</div>
          </ng-template>
        </p-select>
      </div>
      <div class="col-2"><label for="editFurtherInformationUrl">Link für weitere Informationen:</label></div>
      <div class="col-10"><input type="text" id="editFurtherInformationUrl" pInputText [(ngModel)]="timetableEntry.furtherInformationUrl" style="width: 100%" /></div>
      <div class="col-2"><label for="editNotes">Hinweise zur Veranstaltung:</label></div>
      <div class="col-10"><input type="text" id="editNotes" pInputText [(ngModel)]="timetableEntry.notes" style="width: 100%" /></div>
      <div class="col-2"><label for="editTags">Tags:</label></div>
      <div class="col-10">
        <p-listbox [options]="groupedTags" [group]="true" [(ngModel)]="timetableEntry.tagIds" [listStyle]="{'max-height': '250px'}" [multiple]="true">
        </p-listbox>
      </div>
    </div>
    <div style="text-align: right; margin-top: 2ex">
      <p-button (click)="cancel()" label="{{timetableEntry.id===0?'Abbrechen':'Zurück'}}" [style.margin-left.ex]="1" ariaLabel="Zurück"></p-button>
      @if (timetableEntry.id!==0) {
        <p-button (click)="showAttendeeList()" label="Teilnehmer anzeigen" [style.margin-left.ex]="1" ariaLabel="Teilnehmer anzeigen"></p-button>
      }
      <p-button (click)="updateTimetableEntry()" label="Speichern" [style.margin-left.ex]="1" ariaLabel="Speichern"></p-button>
    </div>
  </div>
}
